export default __webpack_public_path__ + "static/media/logout.eaed27b1.svg";